import React from 'react';
import { Box, Button, Slider, Typography } from '@mui/material';
import { useLanguage } from '../../i18n/LanguageContext';
import { NodeCardShell } from './NodeCardShell';
import { NodeCardProps } from './NodeCardProps';

export const ShutterNodeCard: React.FC<NodeCardProps> = ({
  node, index, onCommand, onSettingsChange, onEditOpen,
}) => {
  const { t } = useLanguage();
  const s = node.settings ?? {};
  const position = s.position ?? 0;

  return (
    <NodeCardShell node={node} index={index} onEditOpen={onEditOpen}>
      <Box display="flex" gap={1} mb={1.5}>
        <Button
          variant="outlined" size="small"
          onClick={() => onCommand('open')} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.shutterOpen}
        </Button>
        <Button
          variant="outlined" size="small"
          onClick={() => onCommand('stop')} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.shutterStop}
        </Button>
        <Button
          variant="outlined" size="small"
          onClick={() => onCommand('close')} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.shutterClose}
        </Button>
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="caption" color="text.secondary" sx={{ minWidth: 56 }}>
          {t.shutterPosition}
        </Typography>
        <Slider
          aria-label={t.shutterPosition}
          value={position}
          min={0} max={100} step={5}
          onChange={(_, v) => onSettingsChange({ ...s, position: Array.isArray(v) ? v[0] : v })}
          onChangeCommitted={(_, v) => {
            const val = Array.isArray(v) ? v[0] : v;
            onSettingsChange({ ...s, position: val });
            onCommand('setPosition', { value: String(val) });
          }}
          size="small" sx={{ flex: 1 }}
        />
        <Typography variant="caption" sx={{ minWidth: 36, textAlign: 'right' }}>
          {position}%
        </Typography>
      </Box>
    </NodeCardShell>
  );
};
